import { Box, Divider, Stack, Typography, styled } from "@mui/material";
import { Article, Assignment, Description, Download, Language, OpenInNew } from '@mui/icons-material';
import { useEffect, useState } from "react";

export default function ProductInformation({ product }) {
  const [content, setContent] = useState({})

  useEffect(() => {
    if (product) {
      setContent(sortContent())
    }
  }, [product])

  const sortContent = () => {
    let sortedContent = {}

    product.content.forEach(item => {
      if (sortedContent?.[item.contentgroup]) {
        sortedContent[item.contentgroup].push(item)
      }
      else {
        sortedContent[item.contentgroup] = [item];
      }
    })

    return sortedContent
  }

  const getHeaderIcon = (contentType) => {
    switch (contentType) {
      case "UserGuide":
        return <Description />;
      case "Application Manual":
        return <Assignment />;
      case "Specifications":
        return <Article />;
      case "Software and Webservice":
        return <Language />;
      default:
        return <Description />;
    }
  }

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      sx={{
        justifyContent: 'space-between',
      }}
      spacing={1}
    >
      <Box
        sx={{
          width: '100%',
          '&>*': {
            marginTop: 1
          }
        }}
      >
        {
          Object.keys(content).map(contentType => (
            <Box
              key={contentType}
            >
              <ProductHeader
                icon={getHeaderIcon(contentType)}
                title={contentType}
              />
              <Divider />
              {
                content[contentType].map((item, itemIndex) => (
                  <ProductListItem
                    key={`${item.contenttitle}-${itemIndex}`}
                    title={item.contenttitle}
                    product={item}
                    onClick={() => window.open(item.contenturl, '_blank')}
                  />
                ))
              }
            </Box>
          ))
        }
      </Box>
      <Box
        sx={{
          minWidth: '30%',
        }}
      >
        {
          product && product?.image && product?.image.length > 0 &&
          product.image.map(image => (
            <Box
              key={image.id}
              sx={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <img
                src={image.imageurl}
                style={{
                  width: '250px',
                  aspectRatio: 'auto',
                }}
              />
            </Box>
          ))
        }
      </Box>
    </Stack >
  )
}

const ProductHeaderStyle = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  '& >*': {
    marginRight: '8px',
  },
  '& last-child': {
    marginRight: '0px',
  }
}));

const ProductListItemStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: '8px',
  flexDirection: 'column',
  borderRadius: theme.spacing(.5),
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: 'rgba(145, 158, 171, 0.068)',
    border: `2px solid ${theme.palette.primary.main}`,
    padding: '6px',
  },
}));

const ProductHeader = ({ title, icon }) => (
  <ProductHeaderStyle>
    {icon}
    <Typography variant="h6">
      {title}
    </Typography>
  </ProductHeaderStyle>
)

const ProductListItem = ({ title, product, onClick }) => {
  return (
    <ProductListItemStyle
      onClick={onClick}
    >
      <Box>
        {title}
        <Box
          sx={{
            float: 'right',
            cursor: 'pointer',
            display: 'flex',
            '& >*': {
              mr: '4px'
            }
          }}
        >
          {product.contenttype === 'Software' ? <Download /> : <OpenInNew />}
          <Typography variant='button'>
            {product.contenttype}
          </Typography>
        </Box>
      </Box>
      {product?.contentdescription && product?.contentdescription}
    </ProductListItemStyle>
  )
}